var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#00AEBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12061 13.1821H8V8.47123C8 8.21184 8.21533 8 8.479 8H11.8203V9.10386H9.12061V13.1821ZM13.7144 22H8.479C8.21387 22 8 21.7882 8 21.5259V16.1435H13.7144V22ZM15.8794 9.09089V8H19.7378V9.09089H15.8794ZM22.6001 8H25.521C25.7861 8 26 8.21184 26 8.47123V13.1879H24.8794V9.09089H22.6001V8ZM26 16.2242V21.5273C26 21.7882 25.7847 21.9986 25.521 21.9986H22.6001V20.8976H24.8823C24.8823 19.4839 24.8823 17.6393 24.8823 16.2242H26ZM19.7393 22H15.8735V20.8976H19.7393V22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolutionIcon);
export default __webpack_public_path__ + "static/media/resolutionIcon.8f87619ee03b315e757ed00d5c6eda17.svg";
export { ForwardRef as ReactComponent };